import React, { useState } from 'react';
import { Form, FormGroup, Label, Card, Input } from 'reactstrap';
import { DragAndDrop } from 'components/DragAndDrop';
import { FileView } from 'views/Dialer/list/components/fileView';
import { FaRegFileAlt } from 'react-icons/fa';
import DataPreview from './DataPreview';

/**
 * Um componente para upload de arquivos com funcionalidade de arrastar e soltar.
 *
 * @component
 * @param {Object} props - As propriedades do componente.
 * @param {Function} props.handleFileChange - A função para lidar com eventos de mudança de arquivo.
 * @param {Object} props.fileInfo - As informações sobre o arquivo selecionado.
 * @param {File} [props.fileInfo.file] - O objeto do arquivo selecionado.
 * @param {boolean} props.fileInfo.hasHeader - Se o arquivo possui uma linha de cabeçalho.
 * @param {Function} props.changeHasHeader - Função para alternar o estado hasHeader.
 * @param {boolean} props.isDisabled - Se o upload de arquivo está desativado.
 * @returns {JSX.Element} O componente FileUpload.
 */

const FileUpload = ({
  handleFileChange,
  fileInfo,
  changeHasHeader,
  isDisabled
}) => {
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  const togglePreview = () => setIsPreviewOpen((prev) => !prev);

  return (
    <>
      <Form>
        <FormGroup>
          <Label className="form-control-label mb-3">
            Insira um arquivo do tipo CSV, XLS ou XLSX{' '}
            <span className="text-danger"> *</span>
          </Label>
          <DragAndDrop
            id="import_file"
            name="import_file"
            acceptedFileExtensions=".csv, .xls, .xlsx"
            changeFile={handleFileChange}
            description="Clique ou arraste para adicionar um arquivo"
            isDisabled={isDisabled}
          />
        </FormGroup>
      </Form>

      {fileInfo.file && (
        <>
          <Card className="mb-4">
            <FileView>
              <FaRegFileAlt />
              {fileInfo.file.name}
            </FileView>
          </Card>
          <DataPreview
            data={fileInfo.data}
            isOpen={isPreviewOpen}
            toggle={togglePreview}
          />
        </>
      )}

      <FormGroup check className="mb-3">
        <Label check>
          <Input
            type="checkbox"
            name="hasHeader"
            checked={fileInfo.hasHeader}
            onChange={changeHasHeader}
            disabled={isDisabled}
          />
          Utilizar primeira linha como cabeçalho
        </Label>
      </FormGroup>
    </>
  );
};

export default FileUpload;
